import 'factory/REST';
import 'factory/util';
import 'factory/loadPDF';
import 'factory/alert';

angular.module('TInv.ctrl.Login', [
    'ui.bootstrap',
    'TInv.REST',
    'TInv.util',
    'TInv.loadPDF',
    'TInv.alert',
]).controller('LoginCtrl', function ($log, $scope, $http, $q, $window, $document, $uibModal, revision, REST, NaturalSort, loadPDF, alert) {
    // detect necessary features
    $scope.supported = ('FileReader' in $window) && ('Blob' in $window) && ('Uint8Array' in $window);
    $scope.iOS = navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
    $scope.lang = 1;
    try {
        if ($window.navigator.language.startsWith('it'))
            $scope.lang = 0;
    } catch (e) {
        // default to English
    }
    $scope.changeLanguage = function () {
        $scope.lang = $scope.lang ? 0 : 1;
    };

    $document.on('drop dragover', function (e) {
        $log.debug('Ignoring “' + e.type + '” event on document, as it would change page.');
        e.preventDefault();
        e.dataTransfer.dropEffect = 'none';
    });
    $scope.state = 'login';
    $scope.setState = function (st) {
        $log.debug('Changed state.');
        $scope.state = st;
    };
    
    $scope.fatturaForm = {};
    $scope.fatturaForm.xml = '';
    $scope.showAcceptFn = false;
    $scope.clients = [];
    $scope.hasClients = false;
    $scope.clientsNumber = 0;
    
    $scope.selected = {};
    
    $scope.selected.client = {
        'Nome': null,
        'IdCodice': null,
    };
    
    $scope.clientInfo = {};

    
    $scope.login = {
        cedente: localStorage.login,
        pass: null,
        logged: false,
        error: null,
        success: null,
        image: null,
        denominazione: null,
        crediti: null,
        attivo: '',
        sospeso: '',
        role: null,
        flat: false,
      
    };
    
    $scope.loginUser = function() {
        $scope.login.error = null;
        REST.info($scope.login.cedente, $scope.login.pass).then(function (data) {
            $log.debug(data);
            localStorage.login = $scope.login.cedente;
            $scope.login.denominazione = data.Denominazione;
            $scope.login.crediti = data.Crediti;
            $scope.login.attivo = data.Attivo;
            $scope.login.sospeso = data.Sospeso;
            $scope.login.manager = data.Role === 'ADMIN' || data.Role === 'MANAGER';
            $scope.login.admin = data.Role === 'ADMIN';
            $scope.login.soglia = data.SogliaCrediti;
            $scope.login.flat = data.Flat;
            $scope.setState('hello');
        }).catch(function(err){
            $log.debug('Messaggio di errore Login');
            $log.debug(err);
            if(err.message === 'Password scaduta' || err.message === 'Primo accesso'){
                $scope.resetPwd.expiredPwd = true;
            }
            $scope.login.error = err.message;
        });
        // search for specific logo
        var url = 'images/'+$scope.login.cedente+'.png';
        $http.head(url).then(function () {
            $scope.login.image = url;
        }).catch(function () {
            // custom logo not present, ignore it
        });
    };
    $scope.logoutUser = function() {
        $scope.login.cedente = '';
        $scope.login.pass = '';
        $scope.login.image = null;
        localStorage.login = '';
        $scope.setState('login');
    };
    $scope.refresh = function () {
        // reqeust a refresh to all controllers
        $scope.$broadcast('refresh');
    };
    $scope.sendXML = function (filename, destinatario, committente, body) {
        return REST.send($scope.login.cedente, $scope.login.pass, destinatario, committente, body
        ).then(function(progressivoInvio){
            alert.warning(
                'Invoice correctly sent.\n' +
                'The progressive id assigned to the invoice is: ' + progressivoInvio + '.');
            $log.debug('Accepting invoice');
            return REST.accept($scope.login.cedente, $scope.login.pass, filename);
        }).then(function(){
            $scope.refresh();
            $scope.setState('list-att');
        }).catch(alert.error);
    };

    $scope.uploadPDF = function () {
        loadPDF(true, $scope.selected.client, $scope.login.cedente, function (scope) {
            var tot = scope.files.length,
                err = 0;
            scope.status = [ 'Start sending ' + (tot == 1 ? 'a PDF' : tot + ' PDFs') + '.' ];
            var actions = scope.files.map(function (f) {
                return REST.upload($scope.login.cedente, $scope.login.pass,
                    f.name,
                    f.type,
                    f.content
                ).then(function () {
                    //scope.status.push('Fattura “' + f.name + '” presa in carico con progressivo “' + progressivoInvio + '”.');
                    scope.status.push('File '+f.name+' uploaded!');
                    // remove uploaded files from list
                    scope.remove(f, true);
                }).catch(function (ex) {
                    ++err;
                    $log.info('Upload error:', ex);
                    scope.status.push('Invoice “' + f.name + '” error: ' + ex.message + '.');
                });
            });
            
            $q.all(actions
            ).catch(function () {
                // shouldn't happen, already managed individually
            }).then(function () {
                scope.status.push('Fine upload (errori: ' + err + ' su ' + tot + ').');
            });
        });
    };

    $scope.refuseMessage = function (fname) {
        var parent = $scope;
        $uibModal.open({
            templateUrl: 'template/refuseMessage.html?rev=' + revision,
            controller: function ($scope, $uibModalInstance) {
                $scope.cancel = function () {
                    $uibModalInstance.dismiss('cancel');
                };
                $scope.refuse = function () {
                    parent.refuseBilling(fname, $scope.refuseString);
                    $uibModalInstance.close();
                };
            },
        });
    };

    $scope.refuseBilling = function (fname, descrizione) {
        $scope.error = null;
        $scope.receivedBill = true;
        REST.refuse($scope.login.cedente, $scope.login.pass, fname, descrizione
        ).then(function (){
            $scope.list();
        }).catch(alert.error);
    };

    $scope.natural = function (field) {
        return function (item) {
            return NaturalSort.value(item[field]);
        };
    };
});
